var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeafvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.099 0V3.01083C27.099 17.5035 19.0104 24.0867 9.03401 24.0867H6.1707C6.48985 19.5524 7.90193 16.808 11.5872 13.5472C13.3997 11.944 13.2462 11.0181 12.3534 11.5496C6.20533 15.2077 3.15084 20.1515 3.01535 28.0459L3.01083 28.6029H0C0 26.551 0.174628 24.6888 0.520874 22.9847C0.175632 21.0367 0.00250892 18.3932 0.00150531 15.0542C0.00150531 6.73975 6.74126 0 15.0557 0C18.0665 0 21.0773 1.50542 27.099 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafvector);
export default __webpack_public_path__ + "static/media/leafvector.3084874be2efd57dcdfc5fcab715b7ca.svg";
export { ForwardRef as ReactComponent };